export default "__VITE_PUBLIC_ASSET__24efaf5d__"